/**
 * @param keyArr
 * @param obj
 * @deprecated I don't know what possesed me to write this and think to myself this was a good pattern to use.
 */
export default function <T>(
  keyArr: string[] | string,
  obj: Record<string, T> | void,
): T | undefined {
  let ret: any

  if (!obj) return

  if (typeof keyArr === 'string') keyArr = [keyArr]

  for (const key in keyArr) {
    if (typeof ret === 'undefined') ret = obj[keyArr[key]]
    else ret = ret[keyArr[key]]
  }

  return ret
}
